// validation.js
import { t } from '@web-solutions/module-localization';
import { Filter } from 'bad-words';

const filter = new Filter();

export const validateName = (inputName: string) => {
  let errorMessage = '';

  if (!inputName) {
    return {
      isValid: false,
    };
  }

  const minLengthRegex = /^.{2,}$/;
  const maxLengthRegex = /^.{1,30}$/;
  const specialCharsRegex = /^[^0-9!@#$%^&+=_*(),.?":{}|<>]*$/;

  if (!minLengthRegex.test(inputName)) {
    errorMessage = t('onboarding.name.errorMessages.short');
  }
  if (!maxLengthRegex.test(inputName)) {
    errorMessage = t('onboarding.name.errorMessages.long');
  }
  if (!specialCharsRegex.test(inputName)) {
    errorMessage = t('onboarding.name.errorMessages.specialCharacters');
  }
  if (filter.isProfane(inputName)) {
    errorMessage = t('onboarding.name.errorMessages.another');
  }

  return {
    isValid: errorMessage.length === 0,
    errorMessage: errorMessage.length > 0 ? errorMessage : ''
  };
};
